import {brandConfigObjectMap,} from "./brandConfig";

export const brandConfigMap = new Map();

export function getBrandConfig(productId) {
    const brandConfigObject = brandConfigObjectMap.get(productId);
    return {
        productId,
        gameTitle: brandConfigObject.gameTitle,
        gameTag: brandConfigObject.gameTag,
        gameUrl: brandConfigObject.gameUrl,
        termsConditionsUrl: brandConfigObject.termsConditionsUrl,
        serviceId: brandConfigObject.serviceId,
        brand: brandConfigObject.brand,
        backgroundColor: brandConfigObject.backgroundColor,
        textColor: brandConfigObject.textColor,
        borderColor: brandConfigObject.borderColor,
        showTermsConditions: brandConfigObject.showTermsConditions !== false,
        voucherBackground: brandConfigObject.voucherBackground || false,
        redeemButton: brandConfigObject.redeemButton || false,
    }
}
